import { useAuthStore } from '@stores/auth';
import type { LocationQuery, RouteRecordName } from 'vue-router';

const handleNoLoggedIn = (name: RouteRecordName, query?: LocationQuery) => {
    if (name === 'auth' || name === 'banners-log-in') return;
    if (name === 'banners-logged-in')
        return navigateTo({ name: 'banners-log-in', query });
    return navigateTo({ name: 'auth', query });
};

export default defineNuxtRouteMiddleware((to) => {
    if (to.meta.skipAuthMiddleware) return;
    const { name, query } = to;
    const { isUserLoggedIn } = useAuthStore();

    if (!isUserLoggedIn) {
        return handleNoLoggedIn(name || '', query);
    }

    if (to.name === 'auth') return navigateTo({ name: 'index' });
    if (to.name === 'banners-log-in')
        return navigateTo({ name: 'banners-logged-in', query });
});
